import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ThemeProvider } from 'styled-components';
import { AgentProvider } from '@Providers';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { initializeAwsRum } from '@Analytics';
import { persistor, store } from '@Store';
import { bopsTheme } from '@Themes';
import { AgentRuntimeProvider } from './CustomHooks/Agents';
import App from './app';
import config from './config';
import { initializeSentry, reportWebVitals } from './Initialization';
import { Auth0WithHistoryProvider } from './Providers';

import './Initialization/i18Next';

initializeAwsRum();
initializeSentry();

const container = document.getElementById('root');
const root = createRoot(container);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    },
  },
});

const InnerControls = (
  <QueryClientProvider client={queryClient}>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={bopsTheme}>
          <AgentProvider>
            <AgentRuntimeProvider>
              <App />
            </AgentRuntimeProvider>
          </AgentProvider>
        </ThemeProvider>
      </PersistGate>
    </ReduxProvider>
  </QueryClientProvider>
);

root.render(
  <BrowserRouter>
    {config.isLogycaFlavor && InnerControls}
    {!config.isLogycaFlavor && <Auth0WithHistoryProvider>{InnerControls}</Auth0WithHistoryProvider>}
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
